import { LOGIN } from '@hotjar/webapp/constants/routes/auth';
import { logout } from '../domains/authentication/api/api';

function redirectToLoginScreen() {
  const url = new URL(window.location.href);
  const currentUrl = `${url.pathname}${url.search}${url.hash}`;
  url.pathname = LOGIN.path;
  url.search = `?next=${encodeURIComponent(currentUrl)}`;
  window.location.replace(url.toString());
}

export const logoutAndRedirect = async (): Promise<void> => {
  await logout().finally(() => {
    redirectToLoginScreen();
  });
};
